import { _IsAS } from './common';
/**
 * 提供原生方法唤起统一方法接口
 * @param iosMethod: ios原生方法
 * @param androidMethod: android原生方法
 * @param param: 传递参数(一般是字符串...为什么原生不传数字orz?????)
 */


const methodInvoke = (iosMethod: string, androidMethod: string, param: any, callback?: ()=> void) => {
  if (_IsAS() === 1) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers[iosMethod]
    ) {
      window.webkit.messageHandlers[iosMethod].postMessage(param);
    } else {
      callback && callback();
    }
  } else if (_IsAS() === 2) {
    if (
      window.android &&
      window.android[androidMethod]
    ) {
      window.android[androidMethod](param);
    } else {
      callback && callback();
    }
  }  else if (_IsAS() === 3) {
    if (window.harmony && window.harmony[androidMethod]) {
      window.harmony[androidMethod](param);
    } else {
      callback && callback();
    }
  }
};
/**
 * webview app内跳转
 * @param href: 跳转地址
 */
let routerToNativePage = (href: string) => {
  let url = `zuowenzhitiao://main/webView?url=${href}`;
  methodInvoke('routerAppUrl', 'routerAppUrl', url)
};
/**
 * app内原生页面跳转
 * @param href: 跳转地址
 */
let routerToPage = (href:string) => {
  methodInvoke('routerAppUrl', 'routerAppUrl', href)
}
/**
 * 复制
 * @param copyStr: 复制内容
 */
let copyAction = (copyStr: string) => {
  methodInvoke('copyAction', 'copyAction', copyStr)
}

/**
 * 返回app上一级
 * @param status: 1 直接返回上一级 空字符串为原有逻辑
 */
let callAppBack = (status = "") => {
  methodInvoke('NavBackAction', 'navBackAction', status)
}
/**
 * 分享方法
 * @param shareStr: 分享对象序列化成的字符串
 * @param title: 分享标题
 * @param detail: 分享的介绍
 * @param url: 分享链接
 * @param thumbUrl:分享简介图片链接
 * @param shareType: 分享渠道
 * @param contentType:分享方式  1链接的形式 2图片
 */
let callShareObject = (shareStr:string) => {
  methodInvoke('ShareModel', 'callShareObject', shareStr)
}
/**
 * 调用商城tips
 * @param type: 1 满分礼盒 2商品详情
 */
let callShareGuide = (type:any) => {
  //1 满分礼盒  2商品详情页
  methodInvoke('callShareGuide', 'callShareGuide', type)
}
/**
 * 上传图片
 * @param apiStr: 序列化的对象字符串
 * @param url: 接口地址
 * @param param: 要传的参数
 */
let callUploadImg = (apiStr:string) => {
  //上传的接口地址
  methodInvoke('callUploadImg', 'callUploadImg', apiStr)
}

let callReady = (str:any) => {
  //ios没有这个方法，通知安卓，页面加载完成
  methodInvoke('callReady', 'callReady', str)
}

let callShowPictures = (dataStr: any) => {
  methodInvoke('callViewPictures', 'callLookAllForMall', dataStr)
}

let callShowTopNavigation = ({ close = 0, refresh = 0, share = 0}:any) => {
  // close 是否隐藏顶部栏的关闭按钮 0 隐藏  1显示
  // refresh 是否隐藏顶部栏的刷新按钮 0 隐藏 1 显示
  // share 是否隐藏顶部栏分享按钮 0 隐藏 1 显示
  methodInvoke('callShowTopNavigation', 'callShowTopNavigation', JSON.stringify({ close, refresh, share}));
}

/**
 * 是否允许分享
 * @param isShare: 是否分享：'1':不是 '0':是
 */
let limitShare = (isShare: string) => methodInvoke('LimitShareModel', 'callLimitShare', isShare);


let callCurrencyRechargeIAP = (orderFee: any) => {
  methodInvoke('callCurrencyRechargeIAP', 'callCurrencyRechargeIAP', orderFee)
}
let callUploadImgNoCrop = (apiStr:any) => {
  //上传的接口地址
  methodInvoke('callUploadImgNoCrop', 'callUploadImgNoCrop', apiStr)
}
//跳转微信小程序
let callWechatApplet = (pathStr:any) => {
  // let pathStr = {
  //   path:wxpath,
  //   id:wxid
  // }
  methodInvoke('callWechatApplet', 'callWechatApplet', pathStr)
}
/**
 * 调用原生toast
 * @param data message: 要显示的字符串  type: info 普通  fail 错误  success 成功
 */
 let callToastAction = (data: any) => methodInvoke('callToastAction', 'callToastAction', _IsAS() === 1 ? data : data.message);
export default {
  routerToNativePage,
  routerToPage,
  copyAction,
  callAppBack,
  callShareObject,
  callShareGuide,
  callUploadImg,
  callReady,
  callShowPictures,
  callShowTopNavigation,
  limitShare,
  callCurrencyRechargeIAP,
  callUploadImgNoCrop,
  callWechatApplet,
  callToastAction
}
